import React from 'react';
import { useI18n } from '../../../../i18n';
import { className } from '../../../lib/className';
import PinIcon from '../../../img/icons/pin-full.png';
import { capitalize } from '../../../misc/misc';
import FuelLevelBalance from './FuelLevelBalance';

const FIELD_NAME = "fuel-level";

function FuelLevelFieldView(props) {
	const { fc } = useI18n();

	const onClick = () => {
		if (props.onClick) {
			props.onClick(props.fieldName);
		}
	}

	return (
		<div
			className={
				className(
					"message-field",
					{
						'clickable': !!props.onClick && !props.pinned,
						'pinned': props.pinned
					}
				)
			}
			title={props.pinned ? null : fc('pin')}
			onClick={props.pinned ? null : onClick}
		>
			<div className="main-block">
				{/*
					Use of capitalize function instead of 'capitalize' class intentionlly
					because 'text-transform: capitalize' applies only to block elements and here we need inline element
				*/}
				<span className="title">{capitalize(props.title) + ':'}</span>
				<FuelLevelBalance withUnits value={props.value} uri={props.uri} />
			</div>
			{props.pinned &&
				<div className="pin-block clickable" onClick={onClick} title={fc('unpin')}>
					<img className="pin-icon" alt="" src={PinIcon} />
				</div>
			}
		</div>
	);
}

FuelLevelFieldView.FieldName = FIELD_NAME;

export default FuelLevelFieldView;